// extracted by mini-css-extract-plugin
export default {"item":"OfferItem_item__dUfyo","title":"OfferItem_title__pl+xu","button":"OfferItem_button__i39s7","description":"OfferItem_description__ojTom"};